import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import NavBar from "../Componentes/NavBar";
import GenericBody from "../Componentes/GenericBody";
import Tabela from "../Componentes/Tabela";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import Stats from "../Componentes/Utils/Stats";
import Overlay from "../Componentes/Overlay";
import SidebarMenu from '../Componentes/SideMenu';
import SideMenuBtn from '../Componentes/SideMenuBtn'

import styled from 'styled-components'
import { useNavigate } from "react-router-dom";

const EPIsHome = () => {

    const navigate = useNavigate();

    const [ loading, setLoading ] = useState( true );

    const tabelaRef = useRef( null )

    const [ epis, setEpis ] = useState([])
    const [ episFilter, setEpisFilter ] = useState([])

    const [ linhas, setLinhas ] = useState( 100 )

    useEffect(() => {

        const element = tabelaRef.current

        if( !element ){

            return;

        }

        const handleScroll = () => {

            const { scrollTop, scrollHeight, clientHeight } = element;

            if( scrollTop + clientHeight >= scrollHeight - 10 ){

                setLinhas(( prev ) => prev + 100);

            }

        }

        element.addEventListener("scroll", handleScroll);

        return () => {

            element.removeEventListener("scroll", handleScroll)

        }

    }, [])

    const getEpis = async () => {

        try{

            setLoading( true )

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/EPI/GetColaboradores/', {
                withCredentials: true
            })
            console.log( data )

            setEpis( data )
            setEpisFilter( data )

        }catch( e ){

            console.error( e )

        }finally{

            setLoading( false )

        }

    }

    useEffect(() => {

        getEpis();

    }, [])

    const funcoes = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.FUNCAO ))].sort(), [ epis ])
    const centro_custos = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.CENTRO_CUSTO ))].sort(), [ epis ])
    const contratos = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.CONTRATO ))].sort(), [ epis ])
    const encarregados = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.ENCARREGADO ))].sort(), [ epis ])

    const [ colabName, setColabName ] = useState('')
    const [ colabMat, setColabMat ] = useState('')

    const [ funcoesSel , setFuncoesSel ] = useState([])
    const [ obrasSel, setObrasSel ] = useState([])
    const [ contratosSel, setContratosSel ] = useState([])
    const [ encarregadosSel, setEncarregadosSel ] = useState([])
    const [ statusEpi, setStatusEpi ] = useState([])
    const [ moSel, setMoSel ] = useState([])

    const handleFilter = useCallback(() => {

        setEpisFilter(
            epis.filter(( item ) => {

                const nameFilter = !colabName || item.NOME.includes( colabName )
                const matFilter = !colabMat || item.MATRICULA.includes( colabMat )

                const funcFilter = !funcoesSel.length || funcoesSel.some( obj => ( item.FUNCAO || '' ).includes( obj.value ))
                const obraFilter = !obrasSel.length || obrasSel.some( obj => ( item.CENTRO_CUSTO || '' ).includes( obj.value ))
                const contratoFilter = !contratosSel.length || contratosSel.some( obj => ( item.CONTRATO || '' ).includes( obj.value ))
                const encarregadosFilter = !encarregadosSel.length || encarregadosSel.some( obj => ( item.ENCARREGADO || '' ).includes( obj.value ))
                const statusFilter = !statusEpi.length || statusEpi.some( obj => ( item.STATUS || '' ).includes( obj.value ))
                const moFilter = !moSel.length || moSel.some( obj => ( item.MAO_OBRA || '' ).includes( obj.value ))

                return nameFilter && matFilter && funcFilter && obraFilter && contratoFilter && encarregadosFilter && statusFilter && moFilter;

            })
        )
    }, [ epis, colabName, colabMat, funcoesSel, obrasSel, contratosSel, encarregadosSel, statusEpi, moSel ])

    useEffect(() => {

        handleFilter();

    }, [ handleFilter ])

    const StatusDiv = styled.div`
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${props =>
            props.status === 'PENDENTE' ? 'red' : 'green'};
    `

    const StatsContainer = styled.div`
        margin: auto;
        display: flex;
        flex-direction: column;
        gap: 5px;
        text-align: center;
        font-weight: bold;
        font-size: 13px;
    `

    const TextoStatTotal = styled.p`
        margin: 0 0 10px 0;
    `

    const TextoStat = styled.p`
        margin: 0;
    `

    const navColab = ( url ) => {

        console.log( 'ok' )
        window.open( url, '_blank' )

    }

    const [ sideOverlay, setSideOverlay ] = useState( false )

    const openSidebar = () => {

        setSideOverlay( true )

    }

    const closeSidebar = () => {

        setSideOverlay( false )

    }

    const handleClick = ( to ) => {

        navigate( to );

    }

    return(
        <>
            <NavBar title="EPI'S" setSideBar={ () => openSidebar() } />
            <GenericBody>
                <GenericHeader>
                    <Filters columns="4" >
                        <FilterContainer
                            type="text"
                            placeholder="COLABORADOR..."
                            valor={ colabName }
                            changeFunc={( valor ) => setColabName( valor )}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="MATRICULA..."
                            valor={ colabMat }
                            changeFunc={( valor ) => setColabMat( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="FUNÇÃO..."
                            options={ funcoes }
                            optType="obj"
                            valor={ funcoesSel }
                            changeFunc={( valor ) => setFuncoesSel( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={ centro_custos }
                            optType="obj"
                            valor={ obrasSel }
                            changeFunc={( valor ) => setObrasSel( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CONTRATO..."
                            options={ contratos }
                            optType="obj"
                            valor={ contratosSel }
                            changeFunc={( valor ) => setContratosSel( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ENCARREGADO..."
                            options={ encarregados }
                            optType="obj"
                            valor={ encarregadosSel }
                            changeFunc={( valor ) => setEncarregadosSel( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="STATUS..."
                            options={[
                                { label: 'OK', value: 'OK' },
                                { label: 'PENDENTE', value: 'PENDENTE' }
                            ]}
                            valor={ statusEpi }
                            changeFunc={( valor ) => setStatusEpi( valor )}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="MÃO DE OBRA..."
                            options={[
                                { label: 'INDIRETA', value: 'I' },
                                { label: 'DIRETA', value: 'D' }
                            ]}
                            valor={ moSel }
                            changeFunc={( valor ) => setMoSel( valor )}
                        />
                    </Filters>
                    <Stats>
                        <StatsContainer>
                            <TextoStatTotal>TOTAL: { episFilter.length }</TextoStatTotal>
                            <TextoStat>EPI'S OK: { episFilter.filter( obj => obj.STATUS === 'OK' ).length }</TextoStat>
                            <TextoStat>EPI'S PENDENTES: { episFilter.filter( obj => obj.STATUS === 'PENDENTE' ).length }</TextoStat>
                        </StatsContainer>
                    </Stats>
                </GenericHeader>
                <Tabela loading={ loading } ref={ tabelaRef } >
                    <thead>
                        <tr>
                            <th></th>
                            <th>MATRICULA</th>
                            <th>COLABORADOR</th>
                            <th>FUNÇÃO</th>
                            <th>MO</th>
                            <th>CENTRO DE CUSTO</th>
                            <th>CONTRATO</th>
                            <th>ENCARREGADO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            episFilter.slice( 0, linhas ).map(( obj, index ) => (
                                <tr
                                    key={ index }
                                    onClick={ () => navColab( `/modulo/ssma/epi/epi-colab/${ obj.MATRICULA }` ) }
                                >
                                    <td>
                                        <StatusDiv status={ obj.STATUS } />
                                    </td>
                                    <td>{ obj.MATRICULA }</td>
                                    <td>{ obj.NOME }</td>
                                    <td>{ obj.FUNCAO }</td>
                                    <td>{ obj.MAO_OBRA }</td>
                                    <td>{ obj.CENTRO_CUSTO }</td>
                                    <td>{ obj.CONTRATO ? obj.CONTRATO : '-' }</td>
                                    <td>{ obj.ENCARREGADO ? obj.ENCARREGADO : '-' }</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
            <Overlay state={ sideOverlay } changeContent={ () => closeSidebar() } >
                <SidebarMenu>
                    <SideMenuBtn button="EPI'S x FUNÇÃO" clickFunc={() => handleClick('./epi-funcao')} />
                    <SideMenuBtn button="LISTA EPI'S" clickFunc={() => handleClick('./epi-lista')} />
                    <SideMenuBtn button="PEDIDOS DE EPI" clickFunc={() => handleClick('./epi-pedidos')} />
                </SidebarMenu>
            </Overlay>
        </>
    )

}

export default EPIsHome;